// eslint-disable-next-line no-restricted-imports
import store from '@/vuex/store';

export class Storage {
    constructor (namespaced = false, crossUI = false) {
        this.namespaced = namespaced;
        this.crossUI = crossUI;
    }

    async get (key, reFetch = false) {
        await store.dispatch('userSettings/loadOne', {
            name: key,
            namespaced: this.namespaced,
            crossUI: this.crossUI,
            reFetch,
        });

        let name = key;
        if (this.namespaced) {
            name = this.crossUI
                ? `${store.state.subscription.active.id}::${key}`
                : `${key}--${store.state.subscription.active.id}`;
        }

        return store.state.userSettings.map[name];
    }

    async set (key, value, force = false) {
        await store.dispatch('userSettings/update', {
            name: key,
            value,
            namespaced: this.namespaced,
            force,
            crossUI: this.crossUI,
        });
    }

    async remove (key) {
        await store.dispatch('userSettings/remove', { name: key, namespaced: this.namespaced, crossUI: this.crossUI });
    }
}

export const UserStorage = new Storage();

export const PerSubscriptionUserStorage = new Storage(true);
